import { defineComponent as _defineComponent } from 'vue';
import AzAdviceCard from '~/components/_next/molecules/AzAdviceCard.vue';
import AzButtonText from '~/components/_next/atoms/AzButtonText.vue';
import MobileFiltersButton from '~/components/ui/CustomStoreFrontUI/MobileFiltersButton.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import AzRadio from '~/components/_next/molecules/AzRadio.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzAccordionItem from '~/components/_next/molecules/AzAccordionItem.vue';
import AzFilter from '~/components/_next/molecules/AzFilter.vue';
import SortSelector from '~/components/ui/SortSelector.vue';
import AzPagination from '~/components/_next/molecules/AzPagination.vue';
import { AisConfigure, AisIndex, AisHits, AisStateResults, AisPagination, AisRefinementList, AisSortBy, AisStats, AisClearRefinements } from 'vue-instantsearch';
import { useAlgoliaSearch } from '~/composables/_next/useAlgoliaSearch';
import useMobileObserver from '~/composables/useMobileObserver';
import { z } from 'zod';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchAdvice',
  props: {
    activeTab: {
      type: Boolean
    }
  },
  emits: ['adviceHit'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useAlgoliaSearch = useAlgoliaSearch(),
      indexAdvice = _useAlgoliaSearch.indexAdvice,
      filtersAdvices = _useAlgoliaSearch.filtersAdvices,
      sortsAdvices = _useAlgoliaSearch.sortsAdvices;
    var route = useRoute();
    var router = useRouter();
    var sidebar = ref(null);
    var aisStateResultsRef = ref(null);
    var pageSchema = z.coerce.number().catch(1);
    var page = computed(function () {
      var parsedPage = pageSchema.parse(route.query.page);
      return parsedPage > 0 ? parsedPage - 1 : 0;
    });
    var query = computed(function () {
      return route.params.term;
    });

    /**
     * Clears the current URL query parameters by pushing an empty query object.
     */
    function clearURL() {
      router.push({
        query: {}
      });
    }

    /**
     * Opens the filters sidebar.
     */
    function openSidebar() {
      var _sidebar$value, _sidebar$value$sideba;
      (_sidebar$value = sidebar.value) === null || _sidebar$value === void 0 ? void 0 : (_sidebar$value$sideba = _sidebar$value.sidebar) === null || _sidebar$value$sideba === void 0 ? void 0 : _sidebar$value$sideba.showModal();
    }
    watch(function () {
      var _aisStateResultsRef$v, _aisStateResultsRef$v2, _aisStateResultsRef$v3, _aisStateResultsRef$v4;
      return (_aisStateResultsRef$v = aisStateResultsRef.value) === null || _aisStateResultsRef$v === void 0 ? void 0 : (_aisStateResultsRef$v2 = _aisStateResultsRef$v.$data) === null || _aisStateResultsRef$v2 === void 0 ? void 0 : (_aisStateResultsRef$v3 = _aisStateResultsRef$v2.state) === null || _aisStateResultsRef$v3 === void 0 ? void 0 : (_aisStateResultsRef$v4 = _aisStateResultsRef$v3.results) === null || _aisStateResultsRef$v4 === void 0 ? void 0 : _aisStateResultsRef$v4.nbHits;
    }, function (newValue) {
      if (newValue) {
        emit('adviceHit', newValue);
      }
    });
    return {
      __sfc: true,
      emit: emit,
      props: props,
      isMobile: isMobile,
      indexAdvice: indexAdvice,
      filtersAdvices: filtersAdvices,
      sortsAdvices: sortsAdvices,
      route: route,
      router: router,
      sidebar: sidebar,
      aisStateResultsRef: aisStateResultsRef,
      pageSchema: pageSchema,
      page: page,
      query: query,
      clearURL: clearURL,
      openSidebar: openSidebar,
      AzAdviceCard: AzAdviceCard,
      AzButtonText: AzButtonText,
      MobileFiltersButton: MobileFiltersButton,
      AzSidebar: AzSidebar,
      AzRadio: AzRadio,
      AzButton: AzButton,
      AzAccordionItem: AzAccordionItem,
      AzFilter: AzFilter,
      SortSelector: SortSelector,
      AzPagination: AzPagination,
      AisConfigure: AisConfigure,
      AisIndex: AisIndex,
      AisHits: AisHits,
      AisStateResults: AisStateResults,
      AisPagination: AisPagination,
      AisRefinementList: AisRefinementList,
      AisSortBy: AisSortBy,
      AisStats: AisStats,
      AisClearRefinements: AisClearRefinements
    };
  }
});